import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/core/api/baseQuery'
import { OperacionSemanalResponse } from '@/modules/Home/interfaces/OperacionSemanal'

/**
 * Datos del bloque "Operación Semanal" del inicio de Perú.
 *
 * `baseQuery` ya trae la URL del backend (con su versionado) y el token, así que acá la ruta va
 * relativa y SIN `/v1`.
 */
export const operacionSemanalApi = createApi({
  reducerPath: 'operacionSemanalApi',
  baseQuery,
  endpoints: (builder) => ({
    /** El parámetro es el LUNES de la semana, en formato `yyyy-MM-dd`. */
    getOperacionSemanal: builder.query<OperacionSemanalResponse, string>({
      query: (lunes) => ({
        url: `/OperacionSemanalBusiness?fechaInicio=${encodeURIComponent(lunes)}`,
        method: 'GET',
      }),
    }),
  }),
})

export const { useGetOperacionSemanalQuery } = operacionSemanalApi
